module.exports = __webpack_public_path__ + "static/media/DSC00097.e65a0bdb.jpg";